import { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { fileUrl } from "../lib/api";

export default function Gallery({ photos, title, tall, counter, badge }) {
  const [ref, embla] = useEmblaCarousel({ loop: false });
  const [sel, setSel] = useState(0);
  const onSelect = useCallback(() => embla && setSel(embla.selectedScrollSnap()), [embla]);
  useEffect(() => {
    if (!embla) return;
    embla.on("select", onSelect);
    return () => embla.off("select", onSelect);
  }, [embla, onSelect]);

  return (
    <div className="relative bg-navy/5" data-no-swipe data-testid="listing-gallery">
      <div className="overflow-hidden md:rounded-3xl" ref={ref}>
        <div className="flex touch-pan-y">
          {photos.map((p, i) => (
            <div key={p} className={`min-w-0 flex-[0_0_100%] ${tall ? "h-[55dvh] md:h-auto md:aspect-[4/3]" : "aspect-[4/3.4] md:aspect-[4/3]"}`}>
              <img src={fileUrl(p)} alt={`${title} ${i + 1}`} className="h-full w-full object-cover" data-testid={`gallery-photo-${i}`} />
            </div>
          ))}
        </div>
      </div>
      {badge && (
        <span className="absolute bottom-3 left-3 rounded-md bg-alert px-2 py-1 text-xs font-extrabold text-white shadow" data-testid="gallery-badge">{badge}</span>
      )}
      {counter && (
        <span className="absolute bottom-3 right-3 rounded-lg bg-navy/60 px-2.5 py-1 text-xs font-semibold text-white backdrop-blur-sm" data-testid="gallery-counter">
          {sel + 1}/{photos.length}
        </span>
      )}
      {photos.length > 1 && (
        <>
          {!counter && <div className="absolute inset-x-0 bottom-3 flex justify-center gap-1.5" data-testid="gallery-dots">
            {photos.map((p, i) => (
              <button
                key={p}
                onClick={() => embla?.scrollTo(i)}
                aria-label={`photo ${i + 1}`}
                className={`h-1.5 rounded-full transition-[width,background-color] duration-300 ${i === sel ? "w-5 bg-brand" : "w-1.5 bg-white/80"}`}
              />
            ))}
          </div>}
          <button onClick={() => embla?.scrollPrev()} className="gallery-arrow left-3" aria-label="prev" data-testid="gallery-prev-btn">
            <ChevronLeft className="h-5 w-5" />
          </button>
          <button onClick={() => embla?.scrollNext()} className="gallery-arrow right-3" aria-label="next" data-testid="gallery-next-btn">
            <ChevronRight className="h-5 w-5" />
          </button>
        </>
      )}
    </div>
  );
}
